import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-subscription-failed",
  templateUrl: "./subscription-failed.component.html",
  styleUrls: ["./subscription-failed.component.scss"],
  standalone: false,
})
export class SubscriptionFailedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
